import { useEffect, useState } from "react";
import "./Rti.css";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const Rti = () => {
  const [banner, setBanner] = useState({ title: "", images: [] ,
  mobile_images: [],});
  const [rtiData, setRtiData] = useState({
    declaration_heading: "Declaration under RTI Act 4(1)(b)",
    declaration_subtitle: "Right to Information Act, 2005",
    info_block_content: "",
    contact_section_heading: "Contact Information",
    contact_cards: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const toArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [val];
};

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/api/sitepages/about-us/rti");
        const data = res.data || {};

        const bannerData = data.banner_data || {};
       const normalizedBanner = {
  title: bannerData.title || bannerData.heading || "",
  images: toArray(bannerData.images),
  mobile_images: toArray(bannerData.mobile_images),
};


        const rd = data.rti_data || {};
        const normalizedRti = {
          declaration_heading: rd.declaration_heading || "Declaration under RTI Act 4(1)(b)",
          declaration_subtitle: rd.declaration_subtitle || "Right to Information Act, 2005",
          info_block_content: rd.info_block_content || "",
          contact_section_heading: rd.contact_section_heading || "Contact Information",
          contact_cards: Array.isArray(rd.contact_cards) ? rd.contact_cards : [],
        };

        if (!cancelled) {
          setBanner(normalizedBanner);
          setRtiData(normalizedRti);
          setError(null);
        }
      } catch (err) {
        console.error("Error fetching RTI data:", err);
        if (!cancelled) {
          setError("Failed to load content.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return null;
  }

  if (error) {
    return null;
  }

  return (
    <>
      <div className="rti-page">
       <DynamicBanner
  title={banner.title}
  bgImage={banner.images}
  bgImageMobile={banner.mobile_images}
/>


        <section>
          <div className="rti-header">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8 text-center">
                  <h4 className="mb-3 text-white">{rtiData.declaration_heading}</h4>
                  <p className="mb-0">
                    <i
                      className="fa fa-hand-rock-o me-2"
                      data-aos="zoom-in"
                      data-aos-duration="1000"
                    ></i>
                    {rtiData.declaration_subtitle}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="declaration-card card">
                  <div className="card-body-rti">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <i className="fa fa-info-circle info-icon"></i>
                      </div>
                      <div className="flex-grow-1">
                        <p className="mb-0" style={{ textAlign: "justify" }}>
                          {rtiData.info_block_content}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="section-divider-rti">
                  <span>{rtiData.contact_section_heading}</span>
                </div>

                <div className="row g-4 mb-5">
                  {rtiData.contact_cards.map((card, idx) => (
                    <div className="col-md-6" key={idx}>
                      <div className="contact-card card">
                        <div className="card-body-rti text-center">
                          <div className="icon-container mx-auto">
                            <i className={`fa ${card.icon || "fa-info-circle"}`}></i>
                          </div>
                          <h3 className="card-title-rti">{card.title || card.name}</h3>
                          <div className="contact-info text-start">
                            {card.name && (
                              <p>
                                <i className="fa fa-user"></i> <strong>{card.name}</strong>
                              </p>
                            )}

                            {card.designation && <p>{card.designation}</p>}

                            {Array.isArray(card.address_lines) &&
                              card.address_lines.map((line, i) => <p key={i}>{line}</p>)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Rti;
